export default "__VITE_ASSET__wvgkH6g4__"